/**
 * @file LoadingOverlay.jsx
 * @description Full-screen loading overlay with spinner
 */

import React from "react";
import PropTypes from "prop-types";

/**
 * LoadingOverlay Component
 *
 * Shows a full-screen overlay with spinner
 * Used during API calls and image processing
 */
export default function LoadingOverlay({
  isLoading = false,
  message = "Processing...",
}) {
  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        <p className="mt-4 text-white font-medium">{message}</p>
      </div>
    </div>
  );
}

LoadingOverlay.propTypes = {
  isLoading: PropTypes.bool,
  message: PropTypes.string,
};
